
export class EditGroupRequest {
    public studyId: number;
    public userPk: number;
    public studyGroupName: string;
    public protocolsToUnCheck: number[] = [];
    public protocolsToCheck: number[] = [];

    constructor(userPk: number, groupPk: number, groupname: string, protocolsToCheck: number[], protocolsToUnCheck: number[]) {
        this.userPk = userPk;
        this.studyId = groupPk;
        this.studyGroupName = groupname;
        this.protocolsToCheck = protocolsToCheck;
        this.protocolsToUnCheck = protocolsToUnCheck;
    }
}
